import {handleActions} from 'redux-actions';
import {normalize, schema} from 'normalizr';

const initialState = { lastFetched: null, data: {}, lastFetchResults: [], isLoading: false };

const companies = handleActions(
  {
    'GET_COMPANIES_SUCCESS': (state, action) => {
      const companySchema = new schema.Entity('companies');
      const normalizedData = normalize(action.payload, [companySchema]);

      return {
        ...state,
        isLoading: false,
        lastFetched: Date.now(),
        data: { ...state.data, ...normalizedData.entities.companies},
        lastFetchResults: [...normalizedData.result]
      };
    },
    'GET_COMPANIES_IN_PROGRESS': (state) => ({...state, isLoading: true}),
    'GET_COMPANIES_FAILURE': (state) => ({ ...state, isLoading: false }),
    'DELETE_COMPANY': (state, action) => {
      const { [action.payload+'']: _, ...data } = state.data;
      const lastFetchResults = state.lastFetchResults.filter(x => x !== action.payload);

      return { ...state, data, lastFetchResults };
    },
  },
  initialState
);

export default companies;


// WEBPACK FOOTER //
// ./src/components/utils/reducers/companies.js